import { StyleSheet } from 'react-native';
import { Buttons } from 'src/theme-v2/buttons';

export const styles = StyleSheet.create({
  button: {
    backgroundColor: 'transparent',
  },
  buttonInner: {},
  buttonHover: {
    backgroundColor: 'transparent',
  },
  buttonPressed: {
    backgroundColor: Buttons.ghost.ButtonGhostBackgroundPressed,
  },
  buttonFocus: {
    backgroundColor: 'transparent',
  },
  buttonDisabled: {
    cursor: 'not-allowed',
    backgroundColor: 'transparent',
  },
  text: {
    color: Buttons.ghost.ButtonGhostTextDefault,
  },
  textHover: { color: Buttons.ghost.ButtonGhostTextHover },
  textPressed: { color: Buttons.ghost.ButtonGhostTextDefault },
  textFocus: { color: Buttons.ghost.ButtonGhostTextDefault },
  textDisabled: {
    color: Buttons.ghost.ButtonGhostTextDisable,
  },
  icon: {
    color: Buttons.ghost.ButtonGhostIconDefault,
  },
  iconHover: {
    color: Buttons.ghost.ButtonGhostIconHover,
  },
  iconPressed: {
    color: Buttons.ghost.ButtonGhostIconDefault,
  },
  iconDisabled: {
    color: Buttons.ghost.ButtonGhostIconDisable,
  },
  iconFocus: {
    color: Buttons.ghost.ButtonGhostIconDefault,
  },
});
